import { registerFragment } from '@neptune/cx/registry';
import './styles.scss';

registerFragment('chroa-large-text', (fragEl, config, meta) => { });

if (import.meta.hot) {
    import.meta.hot.accept();
}
